import { Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import React from "react";

const IndividualBreachedCredentialsModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.breach? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="sm"
		>
			<DialogTitle id="alert-dialog-title">
				{(props.breach)? props.breach.name : ""}
			</DialogTitle>
			<DialogContent>
				{(props.breach)?
					<Stack direction="column" spacing={2}>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Date:`}</span>
							{props.breach.breach_date.toLocaleDateString("en-GB")}
						</Typography>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Compromised Data:`}</span>
							{props.breach.compromised_data}
						</Typography>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Email Address:`}</span>
							{props.breach.email}
						</Typography>
						{(props.breach.password)?
							<React.Fragment>
								{(props.breach.password && props.breach.password.split(",").length > 1)?
									<Typography>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Password:`}</span>
										{props.breach.password}
									</Typography>
								:
									<Typography sx={{ marginBottom: "0.5em" }}>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Password:`}</span>
										<br/>
										{props.breach.password.split(",").map((password, passIndex) => {
											return (
												<React.Fragment sx={{ marginLeft: "2em" }} key={`pass_${passIndex}`}>
													{password}<br/>
												</React.Fragment>
											)
										})}
									</Typography>
								}
							</React.Fragment>
						:
							<Typography>
								<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Password:`}</span>
								{`[unavailable]`}
							</Typography>
						}
					</Stack>
				: <React.Fragment/>
				}
			</DialogContent>
		</Dialog>
	);

}

export default IndividualBreachedCredentialsModal;